import { createSelector } from 'reselect'
import { Report } from './types'

const getReport = (type: string, state: Report) => state.report && state.report[type] ? state.report[type] : null

/** A Redux selector to retrieve Report ID
 * @param state - The Redux state
 * @param {String} - The Report ID
 */

export const selectReportId = createSelector(
  getReport,
  (data) => data && data.reportId ? data.reportId : null
)

/** A Redux selector to retrieve In-Progress state
 * @param state - The Redux state
 * @param {Boolean} - In Progress state
 */

export const selectInitGenReportInProgress = createSelector(
  getReport,
  (data) => data && data.inProgress ? data.inProgress : false
)

/** A Redux selector to retrieve Is-Generating state
 * @param state - The Redux state
 * @param {Boolean} - Is Generating state
 */

export const selectIsGeneratingReport = createSelector(
  getReport,
  (data) => data && data.isGenerating ? data.isGenerating : false
)

/** A Redux selector to retrieve Report URL
 * @param state - The Redux state
 * @param {string} - Report URL
 */

export const selectReportURL = createSelector(
  getReport,
  (data) => data && data.reportUrl ? data.reportUrl : null
)

/** A Redux selector to retrieve Cancellation Status
 * @param state - The Redux state
 * @param {Boolean} - Cancelled
 */

export const selectReportCancelStatus = createSelector(
  getReport,
  (data) => data && data.cancelled ? data.cancelled : false
)

/** A Redux selector to retrieve Report Error
 * @param state - The Redux state
 * @param {String} - ERROR
 */

export const selectReportGenerationError = createSelector(
  getReport,
  (data) => data && data.error ? data.error : false
)
